import { render, staticRenderFns } from "./PaycheckDraftPeriodFormIrrelevantWorkRelations.vue?vue&type=template&id=38b76ef6&scoped=true&"
import script from "./PaycheckDraftPeriodFormIrrelevantWorkRelations.vue?vue&type=script&lang=ts&"
export * from "./PaycheckDraftPeriodFormIrrelevantWorkRelations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b76ef6",
  null
  
)

export default component.exports